import React, { createContext, useContext, useState, useEffect } from 'react';

// Variable global para el estado inicial
let globalTbkInitialState = false;

// Crear el contexto
const TbkConnectionContext = createContext({
    isConnected: false,
    setIsConnected: () => { },
});

// Hook para usar el contexto
export const useTbkConnection = () => useContext(TbkConnectionContext);

// Proveedor del contexto
export const TbkConnectionProvider = ({ children }) => {
    const [isConnected, setIsConnected] = useState(globalTbkInitialState);

    // Actualizar estado global cuando cambie el estado local
    useEffect(() => {
        globalTbkInitialState = isConnected;
    }, [isConnected]);

    return (
        <TbkConnectionContext.Provider value={{ isConnected, setIsConnected }}>
            {children}
        </TbkConnectionContext.Provider>
    );
};